import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73e598cd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "route-list" };
const _hoisted_2 = {
    key: 0,
    class: "mb-5"
};
const _hoisted_3 = {
    key: 0,
    class: "route-subtree"
};
const _hoisted_4 = ["onMouseleave"];
const _hoisted_5 = {
    key: 1,
    style: { "display": "inline-block", "width": "20px" }
};
const _hoisted_6 = {
    key: 1,
    class: "route-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_o_button = _resolveComponent("o-button");
    const _component_o_icon = _resolveComponent("o-icon");
    const _component_router_link = _resolveComponent("router-link");
    const _component_draggable_tree = _resolveComponent("draggable-tree", true);
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (false && !$props.isChild)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createVNode(_component_o_button, {
                        "icon-left": "plus",
                        onClick: $setup.AddRoot
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("Create root route")
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ], true)
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_draggable, {
            list: $props.routes,
            "item-key": "UUID",
            group: { name: 'routes', put: $setup.CanAcceptRoutes },
            "data-route-parent": $props.parent?.UUID || 'root',
            handle: ".routeHandle",
            move: $setup.CanMoveRoute,
            onChange: $setup.Changed
        }, {
            item: _withCtx(({ element }) => [
                element
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: "route is-grabbable routeHandle",
                            onMouseleave: ($event) => ($setup.Collapse(element))
                        }, [
                            _createElementVNode("div", null, [
                                ($setup.HasChildren(element))
                                    ? (_openBlock(), _createBlock(_component_o_icon, {
                                        key: 0,
                                        class: "caret",
                                        pack: "fas",
                                        icon: $setup.IsOpen(element) ? 'chevron-down' : 'chevron-right',
                                        onClick: ($event) => ($setup.ToggleOpen(element))
                                    }, null, 8, ["icon", "onClick"]))
                                    : _createCommentVNode("", true),
                                (!$setup.HasChildren(element))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "   "))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(element.Title), 1)
                            ]),
                            _createElementVNode("div", null, [
                                false
                                    ? (_openBlock(), _createBlock(_component_o_button, {
                                        key: 0,
                                        size: "small",
                                        "icon-left": "ellipsis-h",
                                        onMouseenter: ($event) => ($setup.Expand(element))
                                    }, null, 8, ["onMouseenter"]))
                                    : _createCommentVNode("", true),
                                (!$setup.IsLocalRoute(element))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        ($props.isChild && $setup.RouteExists(element))
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 0,
                                                to: { name: element.VueRouterName },
                                                target: "_blank"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_o_button, {
                                                        size: "small",
                                                        "icon-left": "external-link",
                                                        variant: "primary",
                                                        inverted: ""
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(" View ")
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1032, ["to"]))
                                            : _createCommentVNode("", true),
                                        ($props.isChild)
                                            ? (_openBlock(), _createBlock(_component_o_button, {
                                                key: 1,
                                                size: "small",
                                                "icon-left": "copy",
                                                variant: "success",
                                                inverted: "",
                                                disabled: element.duplicating,
                                                onClick: ($event) => ($setup.TryDuplicate(element))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(" Duplicate ")
                                                ]),
                                                _: 2
                                            }, 1032, ["disabled", "onClick"]))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_o_button, {
                                            size: "small",
                                            inverted: "",
                                            "icon-left": "plus",
                                            variant: "success",
                                            onClick: ($event) => ($setup.TryAdd(element))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(" Add subpage ")
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_o_button, {
                                            size: "small",
                                            inverted: "",
                                            "icon-left": "edit",
                                            variant: "info",
                                            onClick: ($event) => ($setup.TryEdit(element))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(" Edit ")
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_o_button, {
                                            size: "small",
                                            inverted: "",
                                            "icon-left": "trash-alt",
                                            variant: "danger",
                                            onClick: ($event) => ($setup.Remove(element))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(" Delete ")
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 40, _hoisted_4),
                        _createElementVNode("div", null, [
                            ($setup.IsOpen(element))
                                ? (_openBlock(), _createBlock(_component_draggable_tree, {
                                    key: 0,
                                    routes: element.Children,
                                    root: $props.root,
                                    "has-changes": $props.hasChanges,
                                    parent: element,
                                    open: $props.open,
                                    onRemove: $setup.BubbleRemove,
                                    onAdd: $setup.BubbleAdd,
                                    onChange: $setup.BubbleChange,
                                    "is-child": "",
                                    class: "indent-element"
                                }, null, 8, ["routes", "root", "has-changes", "parent", "open", "onRemove", "onAdd", "onChange"]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["list", "group", "data-route-parent", "move", "onChange"])
    ]));
}
